import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

const API = process.env.REACT_APP_API || '/api';

async function post(path, body) {
  const res = await fetch(`${API}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const firstError = data?.errors ? Object.values(data.errors)[0]?.[0] : null;
    throw new Error(data?.error || firstError || data?.message || 'حدث خطأ');
  }
  return data;
}

export function ForgotPassword() {
  const [params] = useSearchParams();
  const loginPath = params.get('portal') === 'client' ? '/support' : '/login';
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { message } = await post('/auth/forgot-password', { email });
      setSent(message);
    } catch (err) { setError(err.message); }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-shell auth-shell-narrow">
        <section className="auth-panel">
          <div className="auth-badge">استعادة الحساب</div>
          <h2>نسيت كلمة المرور؟</h2>
          <p className="auth-sub">أدخل بريدك المسجّل وسنرسل لك رابط إعادة التعيين.</p>

          {error && <div className="login-error">{error}</div>}

          {sent ? (
            <>
              <div className="auth-success">{sent}</div>
              <Link className="btn btn-outline auth-submit" to={loginPath}>العودة لتسجيل الدخول</Link>
            </>
          ) : (
            <form onSubmit={submit} noValidate>
              <div className="form-group">
                <label className="form-label">البريد الإلكتروني</label>
                <input className="form-input" type="text" inputMode="email" autoComplete="username"
                  placeholder="name@example.com" value={email}
                  onChange={e => setEmail(e.target.value.trim())} required autoFocus />
              </div>
              <button className="btn btn-primary auth-submit" disabled={loading || !email}>
                {loading ? 'جاري الإرسال...' : 'إرسال الرابط'}
              </button>
              <div className="auth-alt">
                تذكّرتها؟ <Link className="auth-link" to={loginPath}>تسجيل الدخول</Link>
              </div>
            </form>
          )}
        </section>
      </div>
    </div>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const loginPath = params.get('portal') === 'client' ? '/support' : '/login';
  const token = params.get('token') || '';
  const email = params.get('email') || '';

  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirmation) { setError('كلمتا المرور غير متطابقتين'); return; }
    setError(''); setLoading(true);
    try {
      const { message } = await post('/auth/reset-password', {
        email, token, password, password_confirmation: confirmation,
      });
      setDone(message);
      setTimeout(() => navigate(loginPath), 2500);
    } catch (err) { setError(err.message); }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-shell auth-shell-narrow">
        <section className="auth-panel">
          <div className="auth-badge">استعادة الحساب</div>
          <h2>تعيين كلمة مرور جديدة</h2>
          <p className="auth-sub">{email ? `للحساب: ${email}` : 'الرابط غير مكتمل'}</p>

          {error && <div className="login-error">{error}</div>}

          {done ? (
            <>
              <div className="auth-success">{done}</div>
              <Link className="btn btn-primary auth-submit" to={loginPath}>تسجيل الدخول</Link>
            </>
          ) : (
            <form onSubmit={submit} noValidate>
              <div className="form-group">
                <label className="form-label">كلمة المرور الجديدة</label>
                <input className="form-input" type="password" autoComplete="new-password"
                  placeholder="٨ أحرف على الأقل" value={password}
                  onChange={e => setPassword(e.target.value)} required autoFocus />
              </div>
              <div className="form-group">
                <label className="form-label">تأكيد كلمة المرور</label>
                <input className="form-input" type="password" autoComplete="new-password"
                  value={confirmation} onChange={e => setConfirmation(e.target.value)} required />
              </div>
              <button className="btn btn-primary auth-submit" disabled={loading || !token || !email || password.length < 8}>
                {loading ? 'جاري الحفظ...' : 'حفظ كلمة المرور'}
              </button>
              <div className="auth-alt">
                <Link className="auth-link" to={`/forgot-password${params.get('portal') === 'client' ? '?portal=client' : ''}`}>طلب رابط جديد</Link>
              </div>
            </form>
          )}
        </section>
      </div>
    </div>
  );
}
